import Vue from 'vue';
import Router from 'vue-router';
import Home from './views/Home.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home,
      redirect: 'rooms',
    },
    {
      path: '/rooms',
      name: 'room-list',
      component: () => import(/* webpackChunkName: "room-list" */ './views/Rooms.vue'),
    },
    {
      path: '/rooms/:id',
      name: 'room-details',
      component: () => import(/* webpackChunkName: "room-details" */ './views/RoomDetails.vue'),
    },
    {
      path: '/users',
      name: 'users',
      component: () => import(/* webpackChunkName: "user-list" */ './views/Users.vue'),
    },
    {
      path: '/users/:id',
      name: 'users-id',
      component: () => import(/* webpackChunkName: "user-details" */ './views/UserDetails.vue'),
    },
  ],
});
